export default {
  controlHeightXXL: 48,
  controlHeightMD: 38,
  XXXS: 2,
  paddingXXL: 48,
};
